// Alpine $store('aiCredits') — gevuld vanuit window.__aiBalance (server-side
// gebootstrapt in views/layouts/admin.php) en bijgewerkt via het custom event
// 'ai-credits-updated' dat de Reisassistent / AI-generate dispatchen na een
// succesvolle Claude-call.

document.addEventListener('alpine:init', () => {
  const initial = window.__aiBalance || { plan: 0, bundle: 0, total: 0 };
  window.Alpine.store('aiCredits', {
    plan:   Number(initial.plan)   || 0,
    bundle: Number(initial.bundle) || 0,
    total:  Number(initial.total)  || 0,
    get isLow() { return this.total < 5; },
    set(b) {
      if (!b) return;
      this.plan   = Number(b.plan)   || 0;
      this.bundle = Number(b.bundle) || 0;
      this.total  = Number(b.total)  || 0;
    },
  });
});

window.addEventListener('ai-credits-updated', (e) => {
  const store = window.Alpine && window.Alpine.store && window.Alpine.store('aiCredits');
  if (store && e.detail) store.set(e.detail);
});
